import { useTranslation } from 'react-i18next';
import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@parrot-software/design-system';

interface PaymentHistoryTableSkeletonProps {
  showConcept?: boolean;
  showSubscription?: boolean;
}

/**
 * PaymentHistoryTableSkeleton - Loading placeholder for the payment history table
 */
export const PaymentHistoryTableSkeleton = ({
  showConcept = true,
  showSubscription = true,
}: PaymentHistoryTableSkeletonProps) => {
  const { t } = useTranslation('paymentHistory');

  return (
    <Table wrapperClassName="rounded-lg border">
      <TableHeader>
        <TableRow className="bg-muted hover:bg-muted">
          <TableHead className="pl-1 pr-2.5">
            <div className="flex items-center gap-1">
              <span aria-hidden className="h-6 w-6 shrink-0" />
              {t('columns.paymentDate')}
            </div>
          </TableHead>
          {showSubscription && <TableHead className="px-2.5">{t('columns.subscription')}</TableHead>}
          {showConcept && <TableHead className="px-2.5">{t('columns.concept')}</TableHead>}
          <TableHead className="px-2.5">{t('columns.status')}</TableHead>
          <TableHead className="hidden px-2.5 lg:table-cell">{t('columns.paymentMethod')}</TableHead>
          <TableHead className="px-2.5 text-right">{t('columns.subscriptionAmount')}</TableHead>
          <TableHead className="w-[176px] px-2.5 text-right">{t('columns.invoice')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {Array.from({ length: 5 }).map((_, i) => (
          <TableRow key={`skeleton-${i}`}>
            <TableCell className="py-2.5 pl-1 pr-2.5">
              <Skeleton className="ml-auto h-4 w-20" />
            </TableCell>
            {showSubscription && (
              <TableCell className="p-2.5">
                <Skeleton className="h-4 w-24" />
              </TableCell>
            )}
            {showConcept && (
              <TableCell className="p-2.5">
                <Skeleton className="h-4 w-20" />
              </TableCell>
            )}
            <TableCell className="p-2.5">
              <Skeleton className="h-4 w-14" />
            </TableCell>
            <TableCell className="hidden p-2.5 lg:table-cell">
              <Skeleton className="h-4 w-10" />
            </TableCell>
            <TableCell className="p-2.5 text-right">
              <Skeleton className="ml-auto h-4 w-14" />
            </TableCell>
            <TableCell className="p-2.5 text-right">
              <Skeleton className="ml-auto h-8 w-28 rounded-md" />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
